<mat-progress-bar *ngIf="loading" [attr.data-testId]="testId" mode="indeterminate"></mat-progress-bar>
